import { Modal } from 'components/Modal/Modal';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { useMutation, useQueryClient } from 'react-query';
import showToast from 'components/Toast/Toast';
import { useNavigate, useParams } from 'react-router-dom';
import { regenerateKey } from './utils';
import { useModal } from 'hooks/useModal';
import DetailsKey from './DetailsKey';
import { KeyFormType } from './keys.types';
import Loader from 'components/Loader';

const RegenerateKey = () => {
  const { isOpen, open } = useModal();

  const { client_id, name } = useParams<{ client_id: string; name: string }>();
  const navigate = useNavigate();

  const onClose = () => navigate('..', { replace: true });

  const queryClient = useQueryClient();

  const { mutate, isLoading, data } = useMutation(
    ({ client_id, body }: { client_id: string; body: KeyFormType }) =>
      regenerateKey(client_id, body),
    {
      onSuccess: (_, { body }) => {
        showToast.confirmation({
          title: 'API key regenerated!',
          message: body.label,
        });
        queryClient.refetchQueries('user-settings-api-keys');
        open();
      },
      onError: (error) => {
        showToast.error({
          title: 'Failed to regenerate API key',
          message:
            error instanceof Error ? error.message : 'Something went wrong.',
        });
      },
    },
  );

  const onCloseDetailsKey = () => {
    navigate(`../../${data?.client_id}`, { replace: true });
  };

  const handleRegenerate = () => {
    if (client_id && name) {
      mutate({ client_id, body: { label: name } });
    } else {
      showToast.error({
        title: 'Invalid Input',
        message: 'Client ID and Name are required to regenerate the key.',
      });
    }
  };

  return (
    <>
      {data && (
        <Modal isVisible={isOpen} close={onCloseDetailsKey}>
          <DetailsKey
            title="Key regenerated!"
            onClose={onCloseDetailsKey}
            {...data}
          />
        </Modal>
      )}
      <Modal isVisible={!data} close={onClose} className="w-full max-w-[624px]">
        <div className="p-8">
          <div>
            <h1 className="text-2xl font-bold text-content-base-default">
              Are you sure you want to regenerate this key?
            </h1>
            <p className="mt-2 text-base font-bold text-content-base-subdued">
              Are you sure you want to regenerate this API key? Regenerating
              will invalidate the current key, and you will need to update any
              applications using it.
            </p>
          </div>
          <div className="mt-8 flex gap-5">
            <GraniteButton variant="secondary" size="large" onClick={onClose}>
              Cancel
            </GraniteButton>
            <GraniteButton
              size="large"
              variant="destructive"
              disabled={isLoading}
              onClick={handleRegenerate}
            >
              Regenerate key {isLoading && <Loader height="h-4 w-4" />}
            </GraniteButton>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default RegenerateKey;
